/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const cancelOrderAPI = (payload) => {
    const { jwt, data } = payload;
    const wcEnv = {
        rootUri: '/retention',
    };
    const resourcePath = '/selfservice/order/cancel';

    // const mockResponse = {
    //     status: 200,
    //     data: {
    //         message: "Whole order is cancelled",
    //         orderNumber: "3703302806",
    //         totalCharge: "111.85"
    //     }
    // }
    // return new Promise((resolve, reject) => setTimeout(() => resolve(mockResponse), 1000));

    return restClient.postFacade(wcEnv, resourcePath, jwt, data, null, null, false).then((response) => response);
};

export default cancelOrderAPI;
